@if (processStep && processStepStackFrames?.length) {
    <div class="d-inline-flex flex-row align-items-center flex-wrap lh-base">
        @for (stepFrame of processStepStackFrames; track stepFrame; let isFirst = $first) {
            @if (!isFirst) {
                <span class="mx-2"> / </span>
            }
            <a class="clickable-step"
               (click)="processStepClick.emit(stepFrame)">
                @if (isFirst) {
                    <i class="fal fa-fw fa-home"></i>
                }
                {{ stepFrame.step.name }}</a>
        }
        <span class="mx-2"> / </span>
        <span class="non-clickable-step">{{ processStep!.name }}</span>
    </div>
}
